// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"864":"0cf7ba4f","887":"6b03c410"}[chunkId] + ".chunk.js";
};